import { CookieOptions, createBrowserClient } from "@supabase/ssr";
import { Database } from "#/types/supabase";
import { NO_CACHE_HEADERS } from "#/constants/environment";
import { getCookies, setCookie } from "cookies-next";
import { BrowserSupabase } from ".";
import { CookieMethodsBrowser } from "@supabase/ssr/src/types";

export type CookieArgs = { name: string, value: string, options: CookieOptions };
/** Initializes a client for use in the browser by a user.
 */
export const createSupabaseBrowserClient = (
  ...defaultCookies: CookieArgs[]
): BrowserSupabase => {
  const cookies: CookieMethodsBrowser = {
    async getAll() {
      const cookieObj = await getCookies();
      if (!cookieObj) {
        return null;
      }
      const cookies: { name: string, value: string }[] = [];
      for (const key in cookieObj) {
        if (!(key in cookieObj)) {
          continue;
        }
        const cookieValue = cookieObj[key];
        if (!cookieValue) {
          continue;
        }

        if (typeof cookieValue !== "boolean") {
          cookies.push({ name: key, value: cookieValue });
        } else {
          cookies.push({ name: key, value: `${cookieValue}` });
        }
      }
      return cookies;
    },
    setAll(cookies: CookieArgs[]) {
      for (const { name, value , options } of cookies) {
        setCookie(name, value, options);
      }
    }
  };

  cookies.setAll(defaultCookies);

  const browserSupabase = createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
    {
      global: {
        headers: NO_CACHE_HEADERS
      },
      cookies
    }
  ) as unknown as BrowserSupabase;
  browserSupabase.type = "browser";
  return browserSupabase;
};